// http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
const regExpEscapeReg = /[-\/\\^$*+?.()|\[\]{}]/g;

export function escapeRegexpString(regExpString: string): string {
    return regExpString.replace(regExpEscapeReg, '\\$&');
}
